import { FC, useEffect } from 'react';
import * as React from 'react';

import { CrehanaTFunction } from '@crehana/i18n';
import { Tour, TourStepType, useUITheme } from '@crehana/web';
import { useSavedCoursesContext } from '@crehana/web/ReactContexts/SavedCoursesContext';

import { useCrehanaTranslation } from '@/views/UserDashboard/hooks';
import { SAVED_COURSES_SELECTOR } from '@/views/UserDashboard/routes/config';
import { UserDashboardLocaleKeys } from '@/views/UserDashboard/types';

import useSavedCoursesTourQuery from '../../hooks/useSavedCoursesTourQuery';
import useSavedCoursesUserDashTour from './hooks/useSavedCoursesTour';

const getSteps = (
  t: CrehanaTFunction<UserDashboardLocaleKeys>,
): TourStepType[] => [
  {
    selector: `[data-tour="${SAVED_COURSES_SELECTOR}"]`,
    title: t('UD_SAVED_COURSES_TITLE'),
    desc: t('UD_SAVED_COURSES_TITLE_DESC'),
    position: 'right',
  },
];

const SavedCoursesOnboardingTour: FC<React.PropsWithChildren<unknown>> = () => {
  const { isDark } = useUITheme();
  const t = useCrehanaTranslation();
  const { isEnabledSaveCourses } = useSavedCoursesContext();
  const savedCoursesUserDash = useSavedCoursesUserDashTour({
    skip: !isEnabledSaveCourses,
  });
  const { isOpen, onOpen, onComplete, onSkip } = useSavedCoursesTourQuery();
  const STEPS = getSteps(t);

  useEffect(() => {
    if (isEnabledSaveCourses) {
      setTimeout(() => {
        onOpen();
      }, 1000);
    }
  }, [isEnabledSaveCourses]);

  const isEnabledToShow =
    isEnabledSaveCourses &&
    !savedCoursesUserDash.loading &&
    savedCoursesUserDash.isIncomplete;

  if (!isEnabledToShow) {
    return null;
  }

  return (
    <Tour
      type="default"
      open={isOpen}
      hideWelcome
      steps={STEPS}
      onSkip={onSkip}
      onComplete={onComplete}
      breakpoint="sm"
      isDark={isDark}
    />
  );
};

export default SavedCoursesOnboardingTour;
